export const timeZoneFormat = function (dateString) {
  const syncDate = new Date(dateString)
  // Convert to local time (from UTC timestamp)
  syncDate.setTime(syncDate.getTime() - syncDate.getTimezoneOffset() * 60 * 1000)
  const timezone = new Date().toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'short' }).substring(4)
  const d = `${syncDate.toLocaleDateString()} at ${syncDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} ${timezone}`
  return d
}

export const currentDateFormat = function (dateToConvert) {
  const day = ('00' + dateToConvert.getDate()).slice(-2)
  const month = ('00' + (dateToConvert.getMonth() + 1)).slice(-2)
  const year = dateToConvert.getFullYear()
  const date = `${month}-${day}-${year}`
  return date
}

export const convertToLocalIsoFormat = function (dateString) {
  return new Date(new Date(dateString) - (new Date(dateString).getTimezoneOffset() * 60 * 1000)).toISOString()
}
